// Help & Support URLs - Matching iOS app configuration (www.exac.com)
export const helpUrls = {
  // Terms and Conditions / Rules & Practices
  termsAndConditions: 'https://www.exac.com/chime-terms-and-conditions/',
  
  // Patient Privacy Policy
  patientPrivacy: 'https://www.exac.com/chime-patient-privacy/',
  
  // Community Guidelines
  communityGuidelines: 'https://www.exac.com/chime-community-guidelines/',
  
  // Frequently Asked Questions
  faq: 'https://www.exac.com/chime-frequently-asked-questions/',
  
  // About Chime
  aboutChime: 'https://www.exac.com/chime/',
  
  // About Advita
  aboutAdvita: 'https://advita.com/about-us/',
};

// Help section configuration matching iOS implementation
export const helpSections = [
  {
    title: 'Terms & Conditions',
    items: [
      {
        title: 'Rules & Practices',
        action: 'rulesPractices',
        url: helpUrls.termsAndConditions
      },
      {
        title: 'Patient Privacy',
        action: 'patientPrivacy', 
        url: helpUrls.patientPrivacy
      },
      {
        title: 'Community Guidelines',
        action: 'communityGuidelines',
        url: helpUrls.communityGuidelines
      }
    ]
  },
  {
    title: 'Get Help',
    items: [
      {
        title: 'FAQ',
        action: 'faq',
        url: helpUrls.faq
      },
      {
        title: 'Contact Us',
        action: 'contactUs',
        url: null // This opens the contact form modal
      }
    ]
  },
  {
    title: 'About',
    items: [
      {
        title: 'About Chime',
        action: 'aboutChime',
        url: helpUrls.aboutChime
      },
      {
        title: 'About Advita',
        action: 'aboutAdvita',
        url: helpUrls.aboutAdvita
      }
    ]
  }
];

export type HelpAction = 'rulesPractices' | 'patientPrivacy' | 'communityGuidelines' | 'faq' | 'contactUs' | 'aboutChime' | 'aboutAdvita';